import { INode } from 'aurelia';
import { bindable, customElement } from 'aurelia';
import { IApiService } from '../../../services/api';

const recaptchaCallbackName = 'setRecaptchaReady';
const ready = new Promise(
    (resolve) => (window[recaptchaCallbackName] = resolve)
);

const sitekey = '6LczPy8UAAAAAIntT45GDA7K3hHLBZeBaTWDtfdg';

declare const grecaptcha;

@customElement({
    name: 'recaptcha',
    template: '',
})
export class RecaptchaCustomElement {
    @bindable verified;

    constructor(
        @INode readonly element: INode,
        @IApiService readonly api: IApiService
    ) {
        this.element = element;
        this.api = api;

        this.loadGoogleScript();
    }

    attached() {
        ready.then(() =>
            grecaptcha.render(this.element, {
                sitekey: sitekey,
                theme: 'light',
                callback: () => {
                    const responseValue = grecaptcha.getResponse();

                    if (responseValue.length === 0) {
                        this.verified({ token: false });
                    } else {
                        this.api
                            .verifyCaptchaToken(responseValue)
                            .then((r) => {
                                this.verified({ token: true });
                            })
                            .catch(() => {
                                this.verified({ token: false });
                            });
                    }
                },
                'expired-callback': () => {
                    this.verified({ token: false });
                },
            })
        );
    }

    loadGoogleScript() {
        const script = document.createElement('script');
        script.src = `https://www.google.com/recaptcha/api.js?onload=${recaptchaCallbackName}&render=explicit`;
        script.async = true;
        script.defer = true;
        script.id = 'recaptcha-script';

        if (!document.getElementById('recaptcha-script')) {
            document.head.appendChild(script);
        }
    }
}

    import { Metadata as $$M } from '@aurelia/metadata';
    import { ExpressionKind as $$EK } from '@aurelia/runtime';
    import { Controller as $$C, CustomElement as $$CE, IHydrationContext as $$IHC } from '@aurelia/runtime-html';

    // @ts-ignore
    const controllers = [];

    // @ts-ignore
    if (module.hot) {

    // @ts-ignore
    module.hot.accept();

    // @ts-ignore
    const hot = module.hot;

    let aurelia = hot.data?.aurelia;

    // @ts-ignore
    document.addEventListener('au-started', (event) => {aurelia= event.detail; });
    const currentClassType = RecaptchaCustomElement;

    // @ts-ignore
    const proto = RecaptchaCustomElement.prototype

    // @ts-ignore
    const ogCreated = proto ? proto.created : undefined;

    if (proto) {
      // @ts-ignore
      proto.created = function(controller) {
        // @ts-ignore
        ogCreated && ogCreated.call(this, controller);
        controllers.push(controller);
      }
    }

    // @ts-ignore
    hot.dispose(function (data) {
      // @ts-ignore
      data.controllers = controllers;
      data.aurelia = aurelia;
    });

    if (hot.data?.aurelia) {
      const newDefinition = $$CE.getDefinition(currentClassType);
      $$M.define(newDefinition.name, newDefinition, currentClassType);
      $$M.define(newDefinition.name, newDefinition, newDefinition);
      hot.data.aurelia.container.res[$$CE.keyFrom(newDefinition.name)] = newDefinition;

      const previousControllers = hot.data.controllers ?? [];
      if(previousControllers.length === 0) {
        // @ts-ignore
        hot.invalidate?.();
      }

      // @ts-ignore
      previousControllers.forEach(controller => {
        const values = { ...controller.viewModel };
        const hydrationContext = controller.container.get($$IHC)
        const hydrationInst = hydrationContext.instruction;

        const bindableNames = Object.keys(controller.definition.bindables);
        // @ts-ignore
        Object.keys(values).forEach(key => {
          if (bindableNames.includes(key)) {
            return;
          }
          // if there' some bindings that target the existing property
          // @ts-ignore
          const isTargettedByBinding = controller.bindings?.some(y =>
            y.ast?.$kind === $$EK.AccessScope
              && y.ast.name === key && y.targetProperty
          );
          if (!isTargettedByBinding) {
            delete values[key];
          }
        });
        const h = controller.host;
        delete controller._compiledDef;
        controller.viewModel = controller.container.invoke(currentClassType);
        controller.definition = newDefinition;
        Object.assign(controller.viewModel, values);
        if (controller._hydrateCustomElement) {
          controller._hydrateCustomElement(hydrationInst, hydrationContext);
        } else {
          controller.hE(hydrationInst, hydrationContext);
        }
        h.parentNode.replaceChild(controller.host, h);
        controller.hostController = null;
        controller.deactivate(controller, controller.parent ?? null, 0);
        controller.activate(controller, controller.parent ?? null, 0);
      });
    }
  }